import { Box, Typography } from "@mui/material";
import AuthCard from "../AuthCard/AuthCard.wrapper";
import MyImage from 'assets/images/Congratz.jpg';
import { useRouterState } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";

const confirmEmail = () => {

    const state = useRouterState().location.state as {email?: string}

    const resendEmailMutation = useMutation({
        mutationFn: async(email: string) => {
            const response = await axios.put("https://interviewer.runasp.net/api/users/resend-email", {
                email
            });
            return response.data;
        },
        onSuccess: (data) => {
            toast.success('Check your inbox for the verification link.')
            console.log('success', data);
        },
        onError: (error) => {
            console.log(error);
        }
    })

    const resendEmail = () => {
        if (!state?.email) return;
        resendEmailMutation.mutate(state?.email)
    }
    return (
        <AuthCard>
            <Box sx={{pb: '100px'}}>
                <Typography variant="h1">Confirm your email</Typography>
                <Typography sx={{pt: '8px'}} variant="h4">You should receive confirmation email soon. Click on the link in email to verify your account.</Typography>
                <Box sx={{display: 'flex', flexDirection: {xs: "column", sm: "row"}, gap: '2px', alignItems: {xs: 'start', sm:'center'}, pt: '24px'}}>
                    <Typography sx={{color: 'var(--Interviewer-Black)', marginRight: '2px'}} variant="h4">Still haven’t received a mail?</Typography>
                    <span onClick={() => resendEmail()} style={{textDecoration: 'underline', color: 'var(--Interviewer-Black)', cursor: 'pointer' }}>Click here to resend.</span>
                </Box>
            </Box>
            <Box 
                component='img'
                src={MyImage}
                alt="Image"
                sx={{
                    maxWidth: '220px',
                    maxHeight: '220px',
                    mx: 'auto'
                }}  
            />
        </AuthCard>
    )
};

export default confirmEmail